import React from 'react'
import Link from 'gatsby-link'
import { Container, Row, Col } from 'reactstrap';
import {SocialIcon} from 'react-social-icons';
import styled from 'styled-components';

const FooterHeader = styled.span`
font-size: 25px;
`;

export default () => (
 <Container style={{padding:0, margintop:0}}>
    <Row>
        <Col>
            <FooterHeader>Services</FooterHeader>
            <p></p>
            <b>Austin</b>
            <br />
            Every Sunday 10.30 AM 
            <p></p>
            <b>San Antonio</b>
            <br />
            Saturday Week 3 5.30 PM 
            <p></p>
            <b>St. Louis</b>
            <br />
            Sunday Week 1 and 3 2.00 PM
        </Col>
        <Col>
            <FooterHeader>Locations</FooterHeader>
            <p></p>
            <b>Austin</b>
            <br/>
            7611 Cornerwood Dr
            <br />
            Austin, TX 78717 
            <p></p>
            <b>San Antonio</b>
            <br/>
            24031 Canyon Row 
            <br />
            San Antonio, TX 78260 
            <p></p>
            <b>St. Louis</b>
            <br />
            9 Worcester Court
            <br />
            O'Fallon, MO 63366 
            <p></p>
        </Col>
        <Col>
            <FooterHeader>Information</FooterHeader>
            <p></p>
            <b>(512) 632-4963</b>
        </Col>
        <Col>
            <FooterHeader>Quick Links</FooterHeader>
            <p></p>
            <p><Link style={{color:'white'}}to='/'>home</Link></p>
            <p><Link style={{color:'white'}}to='/about-ifgf/'>about ifgf</Link></p>
            <p><Link style={{color:'white'}}to='/connect-with-us'>connect with us</Link></p>
        </Col>
    </Row>
    
    <Row>
        <Col style={{textAlign:"center"}}>
            <SocialIcon color="white" network="instagram" url="https://www.instagram.com/ifgfaustin/" />
            &nbsp;&nbsp;
            <SocialIcon color="white" network="facebook" url="https://www.facebook.com/ifgfaustin" />
            &nbsp;&nbsp;
            <SocialIcon color="white" network="twitter" url="https://twitter.com/ifgfaustin" />
            &nbsp;&nbsp;
               {/* 
            <SocialIcon color="white" network="vimeo" url="https://vimeo.com/event/25088" />
            &nbsp;&nbsp; */} 
            <SocialIcon color="white" network="youtube" url="https://www.youtube.com/watch?v=tpsIb9qbShw&list=PLwDTrw4NYg8OYF4kaA0SbhzbprwE9QNM0" />
            <p>
            </p>
            <div style={{fontSize:14, padding:"10px"}}>
             To be a <i>MULTI-ETHNIC</i> church where all people find it <i>IRRESISTIBLE</i>, <i>ENGAGING</i> and <i>IMPACTFUL</i>
            </div>
            <div style={{fontSize:12}}>© {(new Date().getFullYear())} IFGF Austin Church All Rights Reserved. </div>
        </Col>
    </Row>
 </Container>
)



// WEBPACK FOOTER //
// ./src/components/footer.js